import React, { useState } from 'react';
import { authService } from '../services/authService';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [selectedServer, setSelectedServer] = useState(authService.currentServer || 'stage');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleServerChange = (e) => {
    const newServer = e.target.value;
    setSelectedServer(newServer);
    authService.setCurrentServer(newServer);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await authService.login(formData.username, formData.password);
      // Навигация произойдет автоматически через App.js
    } catch (err) {
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Evolve Rating API</h2>
        <h3>Login</h3>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="server">Server</label>
            <select
              id="server"
              name="server"
              value={selectedServer}
              onChange={handleServerChange}
              className="form-control"
            >
              <option value="local">Local</option>
              <option value="stage">Stage</option>
              <option value="production">Production</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              autoComplete="username"
              placeholder="Enter your username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              autoComplete="current-password"
              placeholder="Enter your password"
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="login-footer">
          <p className="info-text">
            Use your Evolve Rating API credentials to login
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;